/*
window.addEventListener("dx_init", function(){  
    dx_breakers_init();
});
*/

var win = window;
if(window.parent==window){
    window.addEventListener("load", function(){
        dx_breakers_init();
    });    
}  
window.addEventListener("dx_breaker_init", function(event){ 
    win = window.frames[0]; // is editor
    dx_breaker_init(event.detail.block);
});

function dx_breakers_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-breaker"); 
    for(var i = 0; i<blocks.length; i++){         
        dx_breaker_init(blocks[i]);               
    }   
}    

function dx_breaker_init(block){
    if(block.getAttribute("data-init")=="1"){
        return;
    }
    block.setAttribute("data-init", "1");

    setTimeout(() => {
        dx_breaker_stickOnBottom(block);
    }, 100);
   
    // observe window resize
    window.addEventListener("resize", ()=>{
        dx_breaker_stickOnBottom(block);
    })   
   
    // observe body height change     
    let prevHeight = 0;
    const observer = new ResizeObserver(entries => {   
        const height = entries[0].contentRect.height;       
        if (height !== prevHeight) {
            prevHeight = height;
            dx_breaker_stickOnBottom(block);
        }               
    });
    observer.observe(window.document.body);
    
    // observe class change
    let oldClass=block.classList.contains("is-sticky-bottom");
    const classObserver = new MutationObserver((mutations) => { 
        const currentClass=mutations[0].target.classList.contains("is-sticky-bottom");
        if(currentClass !== oldClass){
            oldClass = currentClass;
            dx_breaker_stickOnBottom(block);
        }
    });
    classObserver.observe(block, { 
        attributes: true, 
        attributeOldValue: true, 
        attributeFilter: ['class'] 
    });

    //dom order
    /*
    let domObserver = new MutationObserver((mutationList) => {
        console.log("dom mutation")
        dx_breaker_stickOnBottom(block);         
    }).observe(block.parentNode, {
        childList:     true
    });
    */
   
}

function dx_breaker_stickOnBottom(block){
   
    const content = win.document.body || win.document.body.getElementsByClassName("is-root-container")[0];
    var defaultSpacing = parseInt(getComputedStyle(content).paddingBottom);
    //var defaultSpacing = parseInt(getComputedStyle(block).marginTop);
    //console.log(defaultSpacing);
    /*
    console.log(block.parentNode.lastChild);
    if(block==block.parentNode.lastChild){
        console.log("last");
    }
*/
    if(block.classList.contains("is-sticky-bottom")){
        //TODO: only when last block
        block.style.marginTop = 0;
        block.style.position = "fixed";
        block.style.width = "100%";
        block.style.bottom = defaultSpacing +"px";
        var bounds = block.getBoundingClientRect();    
        const windowHeight = win.innerHeight;       
        const bodyHeight = win.document.body.offsetHeight;      
        if(bodyHeight + bounds.height > windowHeight){          
            block.style.position = "relative";
            block.style.width = "auto";
            block.style.marginTop = defaultSpacing +"px";
            block.style.bottom = 0;
        }        
   } else {
        block.style.position = "relative";
        block.style.width = "auto";
        block.style.marginTop = defaultSpacing +"px";
        block.style.bottom = 0;
   }
}

  
